import ControlProps from '../../../mixins/ControlProps';
import { CheckboxProperty } from '../enums';
import { StyleSizeType } from '../../../../../../styles/enums';

const CheckboxProps = {
  props: {
    ...ControlProps.props,
    [CheckboxProperty.ClassName]: {
      default: '',
      type: String,
    },
    [CheckboxProperty.Size]: {
      default: StyleSizeType.Small,
      type: String,
    },
  },
};

export default CheckboxProps;
